'use es6';

import styled from 'foundations-theming/utils';
export default styled.div.withConfig({
  displayName: "CalypsoHandleButtonWrapper",
  componentId: "schmcz-0"
})([".hs-private.hs-private.hs-private & .uiButton.uiButton{background-color:", ";border:none;}.hs-private.hs-private.hs-private & .uiButton.uiButton:hover{background-color:", ";border:none;}"], ({
  theme
}) => theme.color['do-not-use-calypso'], ({
  theme
}) => theme.color['do-not-use-calypso-dark']);